import React from "react";
import "./tab.scss";

export interface SubTabProps {
	label: string,
	active?: boolean,
	onClick?: () => void,
}

const SubTab: React.FC<SubTabProps> = ({label, active, onClick}) => {

	const cls = [
		"tabs-tab",
		"sub-tab",
		active && "is-active",
		onClick && "is-clickable",
	].filter(Boolean).join(" ")

	const handleClick = () => {
		onClick && onClick()
	}

	return (
		<div className={cls} onClick={handleClick}>
			{label}
		</div>
	);
};

export default SubTab
